import {createContext} from 'react';

const NetworkConnectionContext = createContext({
  isConnected: false,
  setIsConnected: isConnected => {}
});

export default NetworkConnectionContext;